<div class="new-property-container">
  <h4>Add new property</h4>
  <form [formGroup]="reactiveForm" #formDirective='ngForm' style="display: flex; flex-direction: column">
    <div style="display: flex; justify-content: space-between">
      <mat-form-field appearance="outline" style="width: 45%">
        <mat-label>Property type</mat-label>
        <select matNativeControl formControlName="type" required (change)="typeChange($event)">
          <option [value]=1>House</option>
          <option [value]=2>Townhouse</option>
          <option [value]=3>Apartment</option>
          <!--          <option [value]=5>Lot</option>-->
          <!--          <option [value]=4>House & land package</option>-->
        </select>
      </mat-form-field>
      <mat-form-field appearance="outline" style="width: 45%">
        <mat-label>Status</mat-label>
        <select matNativeControl formControlName="status" required>
          <option [value]=6>Settle</option>
          <option [value]=5>Unconditional</option>
          <option [value]=4>Exchange conditional</option>
          <option [value]=3>Reserved</option>
          <option [value]=2>EOI</option>
          <option [value]=1>Available</option>
          <option [value]=0>Unavailable</option>
        </select>
      </mat-form-field>
    </div>
    <mat-form-field color="accent" appearance="fill" style="width: 45%">
      <mat-label style="color: #656666;">Listing Date</mat-label>
      <input matInput [matDatepicker]="picker" (dateChange)="getListingDate($event)" formControlName="listingDate">
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker [startAt]="reactiveForm.get('listingDate').value" [disabled]="false"></mat-datepicker>
    </mat-form-field>
    <div style="display: flex; justify-content: space-between">
      <mat-form-field color="accent" appearance="fill" style="width: 45%"
        *ngIf="reactiveForm.get('status').value == 4 || reactiveForm.get('status').value == 5 || reactiveForm.get('status').value == 6">
        <mat-label style="color: #656666;">Sold date</mat-label>
        <input matInput [matDatepicker]="picker" (dateChange)="getSoldDate($event)" formControlName="soldDate">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker [startAt]="reactiveForm.get('soldDate').value"
          [disabled]="reactiveForm.get('status').value == 5 || reactiveForm.get('status').value == 6"></mat-datepicker>
      </mat-form-field>
      <mat-form-field color="accent" appearance="fill" style="width: 45%" *ngIf="reactiveForm.get('status').value == 6">
        <mat-label style="color: #656666;">Settled date</mat-label>
        <input matInput [matDatepicker]="picker" (dateChange)="getSettledDate($event)" formControlName="settledDate">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker [startAt]="reactiveForm.get('settledDate').value"
          [disabled]="!(reactiveForm.get('status').value == 6)"></mat-datepicker>
      </mat-form-field>
    </div>

    <div style="display: flex; justify-content: space-between">
      <mat-form-field appearance="outline" style="width: 45%">
        <mat-label>{{this.reactiveForm.get('type').value == 3 ? 'Apartment number' : 'Property number'}}</mat-label>
        <input matInput formControlName="pNumber" required>
      </mat-form-field>
      <mat-form-field appearance="outline" *ngIf="this.reactiveForm.get('type').value == 3" style="width: 45%">
        <mat-label>Apartment floor level</mat-label>
        <input matInput formControlName="level" required>
        <mat-error *ngIf="reactiveForm.get('level').invalid">Invalid floor level (ony
          0-999/GC/GB/GA/G/LG/L/B/B1/B2/B3/B4/B5 are allowed)</mat-error>
      </mat-form-field>
    </div>
    <div style="display: flex; justify-content: space-between">
      <mat-form-field *ngIf="this.reactiveForm.get('type').value == 5" appearance="outline" style="width: 45%">
        <mat-label>Lot number</mat-label>
        <input matInput formControlName="lotNumber" required>
      </mat-form-field>
      <div style="display: flex; justify-content: space-between; width: 45%">
        <mat-form-field appearance="outline" style="width: 45%">
          <mat-label>Commission</mat-label>
          <input matInput formControlName="commission">
        </mat-form-field>
        <mat-form-field appearance="outline" style="width: 45%">
          <mat-label>Commission unit</mat-label>
          <mat-select formControlName="commissionUnit">
            <mat-option value="%">%</mat-option>
            <mat-option value="AUD">AUD</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div style="display: flex; justify-content: space-between">
      <mat-form-field appearance="outline" style="width: 45%" class="aaa">
        <mat-label>{{this.reactiveForm.get('type').value == 5 ? 'Lot price' : 'Price'}}</mat-label>
        <span matPrefix>AUD&nbsp;</span>
        <input class="right-align" matInput type="number"
          onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))" min="0" formControlName="totalPrice"
          required>
        <span matSuffix>.00</span>
      </mat-form-field>
      <mat-form-field appearance="outline" style="width: 45%">
        <mat-label>Extra cost</mat-label>
        <span matPrefix>AUD&nbsp;</span>
        <input class="right-align" matInput type="number"
          onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))" min="0" formControlName="extraCost">
        <span matSuffix>.00</span>
      </mat-form-field>
    </div>
    <div style="display: flex; justify-content: space-between">
      <mat-form-field *ngIf="this.reactiveForm.get('type').value != 5" appearance="outline" style="width: 45%">
        <mat-label>Bed</mat-label>
        <input matInput type="number" onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
          formControlName="bed" min="0" required>
      </mat-form-field>
      <mat-form-field appearance="outline" style="width: 45%">
        <mat-label>Bath</mat-label>
        <input matInput type="number" onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
          formControlName="bath" min="0" required  >
      </mat-form-field>
      <!--      <mat-form-field appearance="outline">-->
      <!--        <mat-label>Living room</mat-label>-->
      <!--        <input matInput type="number" onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))" formControlName="livingRoom">-->
      <!--      </mat-form-field>-->
    </div>
    <div style="display: flex; justify-content: space-between">
      <mat-form-field appearance="outline" style="width: 45%">
        <mat-label>Car space</mat-label>
        <input matInput type="number" onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
          formControlName="car" min="0" required  >
      </mat-form-field>
      <mat-form-field appearance="outline" style="width: 45%">
        <mat-label>Study</mat-label>
        <input matInput type="number" onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
          formControlName="study" min="0" required>
      </mat-form-field>
    </div>
    <div style="display: flex; justify-content: space-between">
      <mat-form-field appearance="outline" style="width: 45%">
        <mat-label>Storeys</mat-label>
        <input matInput type="number" onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
          formControlName="storeys" min="0" required>
      </mat-form-field>
    </div>
    <div style="display: flex; justify-content: space-between">
      <mat-form-field appearance="outline" style="width: 45%">
        <mat-label>Internal size</mat-label>
        <input matInput type="number" onKeypress="return (/[\d|\.]/.test(String.fromCharCode(event.keyCode)))"
          formControlName="internalArea" min="0" required (change)="valueChange($event)">
        <span matSuffix>m²</span>
      </mat-form-field>
    </div>
    <div style="display: flex; justify-content: space-between">
      <mat-form-field appearance="outline" style="width: 45%">
        <mat-label>External size 1</mat-label>
        <input matInput type="number" onKeypress="return (/[\d|\.]/.test(String.fromCharCode(event.keyCode)))"
          formControlName="externalArea1" min="0" required (change)="valueChange($event)">
        <span matSuffix>m²</span>
      </mat-form-field>
      <mat-form-field appearance="outline" style="width: 45%">
        <mat-label>External size 2</mat-label>
        <input matInput type="number" onKeypress="return (/[\d|\.]/.test(String.fromCharCode(event.keyCode)))"
          formControlName="externalArea2" min="0" required (change)="valueChange($event)">
        <span matSuffix>m²</span>
      </mat-form-field>
    </div>
    <div style="display: flex; justify-content: space-between">
      <mat-form-field appearance="outline" style="width: 45%">
        <mat-label>Total size</mat-label>
        <input matInput type="number" onKeypress="return (/[\d|\.]/.test(String.fromCharCode(event.keyCode)))"
          formControlName="totalArea" min="0" required>
        <span matSuffix>m²</span>
      </mat-form-field>
      <mat-form-field appearance="outline" *ngIf="this.reactiveForm.get('type').value != 3" style="width: 45%">
        <mat-label>Land size</mat-label>
        <input matInput type="number" onKeypress="return (/[\d|\.]/.test(String.fromCharCode(event.keyCode)))" min="0"
          formControlName="landArea">
        <span matSuffix>m²</span>
      </mat-form-field>
    </div>
    <div style="display: flex; justify-content: space-between">
      <mat-form-field appearance="outline" style="width: 45%">
        <mat-label>Aspect</mat-label>
        <select matNativeControl formControlName="orientation">
          <option>None</option>
          <option [value]=1>North</option>
          <option [value]=2>South</option>
          <option [value]=3>East</option>
          <option [value]=4>West</option>
          <option [value]=5>North-east</option>
          <option [value]=6>North-west</option>
          <option [value]=7>South-east</option>
          <option [value]=8>South-west</option>
        </select>
      </mat-form-field>
      <mat-form-field appearance="outline" style="width: 45%">
        <mat-label>View</mat-label>
        <select matNativeControl formControlName="view">
          <option>None</option>
          <option [value]=1>Park</option>
          <option [value]=2>Garden</option>
          <option [value]=3>Ocean</option>
          <option [value]=4>Mountain</option>
        </select>
      </mat-form-field>
    </div>
    <mat-form-field appearance="outline" style="width: 45%">
      <mat-label>Description</mat-label>
      <textarea matInput formControlName="description" style="height: 100px"></textarea>
    </mat-form-field>
    <div fxLayout="row" fxLayoutGap="40px">

      <!--      <mat-form-field appearance="outline">-->
      <!--        <mat-label>Land price</mat-label>-->
      <!--        <span matPrefix>AUD&nbsp;</span>-->
      <!--        <input class="right-align" matInput type="number" onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))" formControlName="landPrice">-->
      <!--        <span matSuffix>.00</span>-->
      <!--      </mat-form-field>-->
      <!--      <mat-form-field appearance="outline">-->
      <!--        <mat-label>House price</mat-label>-->
      <!--        <span matPrefix>AUD&nbsp;&nbsp;&nbsp;</span>-->
      <!--        <input class="right-align" matInput type="number" onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))" formControlName="housePrice">-->
      <!--        <span matSuffix>.00</span>-->
      <!--      </mat-form-field>-->
    </div>



    <!--    <mat-form-field appearance="outline">-->
    <!--      <mat-label>Commission fee</mat-label>-->
    <!--      <span matPrefix>AUD&nbsp;</span>-->
    <!--      <input class="right-align" matInput type="number" onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))" formControlName="commissionFee">-->
    <!--      <span matSuffix>.00</span>-->
    <!--    </mat-form-field>-->
    <div style="display: flex; justify-content: space-between">
      <mat-form-field appearance="outline" style="width: 45%">
        <mat-label>Estimated rates</mat-label>
        <span matPrefix>AUD&nbsp;</span>
        <input class="right-align" matInput type="number"
          onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))" min="0"
          formControlName="estimatedRates">
        <span matSuffix>.00</span>
      </mat-form-field>
      <mat-form-field appearance="outline" style="width: 45%">
        <mat-label>Estimated rental returns</mat-label>
        <span matPrefix>AUD&nbsp;</span>
        <input class="right-align" matInput type="number"
          onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))" min="0"
          formControlName="estimatedRentalReturns">
        <span matSuffix>.00</span>
      </mat-form-field>
    </div>
    <mat-form-field appearance="outline" style="width: 45%">
      <mat-label>Estimated owner's corporation fees</mat-label>
      <span matPrefix>AUD&nbsp;</span>
      <input class="right-align" matInput type="number"
        onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))" min="0"
        formControlName="estimatedOwnersCorporationFee">
      <span matSuffix>.00</span>
    </mat-form-field>
    <div style="display: flex; justify-content: space-between">
      <mat-form-field appearance="outline" style="width: 45%">
        <mat-label>Stamp duty</mat-label>
        <span matPrefix>AUD&nbsp;</span>
        <input class="right-align" matInput type="number"
          onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))" min="0" formControlName="stampDuty">
        <span matSuffix>.00</span>
      </mat-form-field>
      <mat-form-field appearance="outline" style="width: 45%">
        <mat-label>Council fee</mat-label>
        <span matPrefix>AUD&nbsp;</span>
        <input class="right-align" matInput type="number"
          onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))" min="0" formControlName="councilFee">
        <span matSuffix>.00</span>
      </mat-form-field>
    </div>

    <div>
      <h4>Terms</h4>
      <input #termsInput style="display: none" type="file" multiple="" (change)="onFileChangeForTerms($event)">
      <button (click)="termsInput.click()" mat-button style="border: 1px solid #bababa; margin-bottom: 20px">
        Click here to select files
      </button>
      <p *ngIf="isFileTooLarge === true" style="color: #f44336; font-size: 14px; margin-top: 0; margin-bottom: 20px">
        File size cannot exceed 40MB.</p>
    </div>
    <ng-container *ngIf="selectedTermsAttachments.length > 0">
      <p *ngFor="let file of selectedTermsAttachments" style="display: flex; align-items: center; margin-top: 0px">
        <mat-icon style="color: #b7b7b7; margin-right: 5px">insert_drive_file</mat-icon>
        {{file.name}} ({{(file.size / 1098304).toFixed(2)}} MB)
      </p>
    </ng-container>
    <div fxLayout="row" fxLayoutGap="20px" fxFlexAlign="center center">
      <button mat-button style="background: #3C50E0; color: white; width: 100px"
        [ngClass]="{'deactivated': reactiveForm.invalid || isCreating, 'activated': !reactiveForm.invalid && !isCreating}"
        [disabled]="reactiveForm.invalid || isCreating" (click)="createProperty(true)">
        Create
      </button>
      <button mat-button style="background: #4fb868; color: white; width: 200px"
        [ngClass]="{'deactivated': reactiveForm.invalid || isCreating, 'activated': !reactiveForm.invalid && !isCreating}"
        [disabled]="reactiveForm.invalid || isCreating" (click)="createProperty(false)">
        Create and add another
      </button>

    </div>
    <div *ngIf="isCreating" style="color: #3C50E0;margin-top: 10px;">Creating property, please don't refresh page.</div>


  </form>

</div>